import React from 'react';
import MyListingTable from './MyListingTable';
import MyReceivedBidsTable from '../bid/MyReceivedBidsTable';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  table: {
    marginBottom: theme.spacing(5)
  }
}))
export default function MyListingsPage() {
  const classes = useStyles();
  return (
    <Box>
      <Box className={classes.table}>
        <MyListingTable />
      </Box>
      <Box className={classes.table}>
        <MyReceivedBidsTable />
      </Box>
    </Box>
  )
}
